// extracted by mini-css-extract-plugin
export var button = "ThemeSwitcher-module--button--7cb7b";
export var dark = "ThemeSwitcher-module--dark--6db0c";
export var moon = "ThemeSwitcher-module--moon--10537";
export var sun = "ThemeSwitcher-module--sun--2163a";
export var themeSwitcher = "ThemeSwitcher-module--themeSwitcher--8a77f";